const WALLET_RK_IDS = {
  coinbase: 'coinbase',
  okx: 'okx',
  metamask: 'metaMask',
  rabby: 'rabby',
  phantom: 'phantom',
  walletconnect: 'walletConnect',
  trust: 'trust',
  rainbow: 'rainbow',
  zerion: 'zerion',
  bitget: 'bitget',
  binance: 'injected',
  bybit: 'injected',
}

const CONNECTOR_ID_ALIASES = {
  coinbase: ['coinbaseWalletSDK', 'coinbase'],
  metamask: ['metaMask', 'metaMaskSDK'],
  okx: ['okx'],
  rabby: ['rabby'],
  phantom: ['phantom'],
  walletconnect: ['walletConnect'],
  trust: ['trust', 'trustWallet'],
  rainbow: ['rainbow'],
  zerion: ['zerion'],
  bitget: ['bitget'],
  binance: ['injected'],
  bybit: ['injected'],
}

function getRkId(connector) {
  return connector?.rkDetails?.id ?? null
}

export function findConnectorForWallet(connectors, walletId) {
  const rkId = WALLET_RK_IDS[walletId]
  if (!rkId) return null

  const rkMatch = connectors.find((connector) => getRkId(connector) === rkId)
  if (rkMatch) return rkMatch

  const aliases = CONNECTOR_ID_ALIASES[walletId] ?? []
  for (const alias of aliases) {
    const match = connectors.find((connector) => connector.id === alias)
    if (match) return match
  }

  return null
}

export function resolveWalletConnectModalConnector(connectors) {
  return connectors.find(
    (connector) => connector.rkDetails?.isWalletConnectModalConnector,
  ) ?? null
}
